import React from 'react';
import DragDropListsCore from '@components-clean/core/drag-drop-lists-core';
import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import { UnfilterableIcon } from '@components-clean/core/icons/unfilterable-icon/unfilterable-icon';
import { PanelData } from '@pages-clean/admin/study/admin-data-views/data-views/types';
import { useTranslation } from '@hooks/index';

const DataViewPanels = ({
    studyPanels,
    dataViewPanelIds,
    unfilterablePanelIds,
}: {
    studyPanels: PanelData[];
    dataViewPanelIds: string[];
    unfilterablePanelIds: string[];
}) => {
    const { t } = useTranslation();

    const data = dataViewPanelIds.reduce<DragDropListItemProps[]>((panels, id) => {
        const panel = studyPanels.find((p) => p.id === id)!;
        if (panel)
            panels.push({
                ...panel,
                suffix: unfilterablePanelIds.includes(panel.id) ? (
                    <UnfilterableIcon
                        dataTestId={`${panel.id}-unfilterable`}
                        className="k-opacity-80"
                        tooltip={t('cm:componentsClean.panels.screenFilterableWarning')}
                        tooltipPosition="bottom"
                        defaultOpacity={75}
                    />
                ) : undefined,
            });
        return panels;
    }, []);

    return (
        <div className="k-h-full">
            <DragDropListsCore list1Header={t('admin:panels')} list1Items={data} idField="Id" disabled />
        </div>
    );
};
export { DataViewPanels };
